export default __webpack_public_path__ + "static/media/framing.3570c35e.jpg";